import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Mail, ArrowUp } from "lucide-react";

// Floating button that scrolls back to the top of the invitation
const FloatingButton = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          data-testid="floating-top-button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full border border-[#E6C8D2] bg-white text-[#B0607A] shadow-[0_12px_28px_-10px_rgba(120,90,10,0.45)]"
          initial={{ opacity: 0, scale: 0.6 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.6 }}
          aria-label="ზედ ასვლა"
        >
          <span className="relative">
            <Mail width={22} height={22} />
            <ArrowUp className="absolute -right-2 -top-2 rounded-full bg-[#B0607A] p-0.5 text-white" width={13} height={13} />
          </span>
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default FloatingButton;
